import { render, staticRenderFns } from "./main-video.vue?vue&type=template&id=a6a2d0a2&"
import script from "./main-video.vue?vue&type=script&lang=js&"
export * from "./main-video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src271809469/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6a2d0a2')) {
      api.createRecord('a6a2d0a2', component.options)
    } else {
      api.reload('a6a2d0a2', component.options)
    }
    module.hot.accept("./main-video.vue?vue&type=template&id=a6a2d0a2&", function () {
      api.rerender('a6a2d0a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main-video/main-video.vue"
export default component.exports